import { RouteObject } from "react-router-dom";
import EmpresaView from "./Empresa/Empresa.View";
import CertificadoView from "./Certificado/Certificado.View";
import PessoaView from "./Pessoa/Pessoa.View";
import PessoaCadastroView from "./Pessoa/Cadastro/PessoaCadastro.View";

export const EntidadeRoutes: RouteObject[] = [
  {
    path: "entidade/empresa",
    element: <EmpresaView />,
  },
  {
    path: "entidade/empresa/certificado",
    element: <CertificadoView />,
  },
  {
    path: "entidade/pessoa",
    element: <PessoaView />,
  },
  {
    path: "entidade/pessoa/cadastro",
    element: <PessoaCadastroView />,
  },
];
